import React from 'react'

import OfficeLogo from 'components/settings/GlobalCalendarSettings/OfficeLogo'
import calendarConnectTeaseSrc from 'images/meetings/tease-calendar-connect.png'

import './style.styl'

const GlobalCalendarInfo = () => (
  <div className="settings-meeting-globally-managed">
    <div className="settings-meeting-globally-managed info">
      <OfficeLogo/>
      <p className="settings-meeting-globally-managed-title">Your org’s calendars are managed by a Drift Admin</p>
      <p className="settings-meeting-globally-managed-description">To start booking meetings with your leads and customers directly through Drift, contact your admin and ask to have your work calendar connected.</p>
    </div>
    <img src={calendarConnectTeaseSrc} />
  </div>
)

export default GlobalCalendarInfo


// WEBPACK FOOTER //
// ./src/scripts/components/settings/meetings/GlobalCalendarInfo/index.js